import React from 'react';
import styles from './Attendee.module.css';
import DefaultProfileImg from '../../../../shared/images/DefaultProfileImg.png';
import RWBMark from '../svgs/RWBMark';
import AdminIcon from '../svgs/AdminIcon';
import {logAccessMemberProfile} from '../../../../shared/models/Analytics';
import {displayMilitaryInfo} from '../../../../shared/utils/Helpers';
import ReportAndDeleteOverlay from '../ReportAndDeleteOverlay';
import { userProfile } from '../../../../shared/models/UserProfile';

const Attendee = ({item, onSelect, sponsorAdmin, minifiedCard, isGroupList, groupName, isGroupAdmin, privilegedIds}) => {
  const {
    profile_photo_url,
    first_name,
    last_name,
    name,
    eagle_leader,
    preferred_chapter,
    military_branch,
    military_status,
  } = item;
  return (
    <div
      className={styles.container}
      onClick={() => {
        onSelect(item);
        logAccessMemberProfile({section_name: 'Member List'});
      }}>
      <div className={minifiedCard ? 'minifiedImgContainer' : styles.imgContainer}>
        <img
          src={!profile_photo_url ? DefaultProfileImg : profile_photo_url}
          className={minifiedCard ? 'minifiedImg' : styles.img}
          alt={'User profile'}
        />
        {sponsorAdmin && (
          <div className={minifiedCard ? 'minifiedAdminIconContainer' : styles.adminIconContainer}>
            <AdminIcon />
          </div>
        )}
      </div>
      <div className={styles.labelContainer}>
        <div className={styles.name}>
          <h3>
            {first_name ? `${first_name} ${last_name}` :  'Deleted Member'}
          </h3>
          {eagle_leader && <RWBMark width={40} height={15} />}
        </div>
        {sponsorAdmin ? <h5>Group Leader</h5> : null}
        {eagle_leader ? <h5>Eagle Leader</h5> : null}
        {!minifiedCard && <p>{preferred_chapter?.name} </p>}
        <p>{displayMilitaryInfo(military_status, military_branch)}</p>
      </div>
      {isGroupList && item.id !== userProfile.getUserProfile().id || item.eagle_leader_info ? <div style={{alignSelf: 'center', display: 'flex', marginLeft:'auto'}}>
        <ReportAndDeleteOverlay
          type="member"
          isGroupList={isGroupList}
          eagle_leader={eagle_leader}
          groupName={groupName}
          isGroupAdmin={isGroupAdmin}
          user={item}
          posterID={item.id}
          hasPermission={privilegedIds?.has(item.id)}
        />
      </div>: null}
    </div>
  );
};

export default Attendee;
